import { ReactElement } from 'react'
import HorizontalRule from 'ui/atoms/HorizontalRule'
import { colors } from 'const/colors'
import { customComponents } from 'configureBrand'
import i18n from 'lang/i18n'
import { NeedAssistanceProps } from './typing'
import { Container, MainContent, Page, Title } from './subcomponents'

const NeedAssistance = ({ children }: NeedAssistanceProps): ReactElement => {
  const { CustomNeedAssistanceContent } = customComponents

  return (
    <Page>
      <MainContent>{children}</MainContent>
      <Container>
        <Title>{i18n({ needAssistance: 'title' })}</Title>
        <HorizontalRule
          isTitleBorder
          topSpacing="16px"
          borderColor={colors.brightGrey}
        />
        <CustomNeedAssistanceContent i18n={i18n} />
      </Container>
    </Page>
  )
}

export default NeedAssistance
